import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from '@bluebeam/react-skyline-button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from '@bluebeam/react-skyline-dialog';
import * as React from 'react';
import './modals.css';

export const accessDeniedModalContainer = 'access-denied-modal-container';

type AccessDeniedModalProps = {
  closeModal: () => boolean;
};

const AccessDeniedModal: React.FC<AccessDeniedModalProps> = ({
  closeModal,
}) => {
  const { translate } = useTranslator(['accessDeniedModal']);

  const [isOpen, setIsOpen] = React.useState<boolean>(closeModal());

  const onCloseHandler = () => {
    closeModal();
    setIsOpen(false);
  };

  const navigateToProjectsPage = (): void => {
    window.location.assign('/projects');
  };

  const isProjectsPage = window.location.pathname.includes('/projects');

  if (isOpen) {
    return (
      <div id="access-denied-modal-container">
        <Dialog
          ariaClose="Close"
          className="accessDeniedModal"
          size="small"
          title={translate('accessDeniedModal:title')}
        >
          <Dialog.Content>
            <p className="font-size-5 regular">
              {translate('accessDeniedModal:bodyText')}
            </p>
          </Dialog.Content>
          <Dialog.Footer>
            {isProjectsPage ? (
              <Button
                size="32px"
                variant="filled"
                id="access-denied-modal-btn"
                onClick={onCloseHandler}
              >
                {translate('accessDeniedModal:okButton')}
              </Button>
            ) : (
              <Button
                size="32px"
                variant="filled"
                id="access-denied-modal-btn"
                onClick={navigateToProjectsPage}
              >
                {translate('accessDeniedModal:viewProjectBtn')}
              </Button>
            )}
          </Dialog.Footer>
        </Dialog>
      </div>
    );
  }

  return null;
};
export default AccessDeniedModal;
